export const EMAIL_NOT_VALID = '이메일 형식이 아닙니다. 다시 입력해주세요.';
export const EMAIL_DUPLICATE = '이미 사용중인 이메일입니다.';
export const NICK_NOT_VALID = '4~16자 한글, 영문 소문자, 숫자, -을 사용하세요.';
export const PW_NOT_VALID =
  '8~16자 영문 대 소문자, 숫자, 특수문자를 사용하세요.';
export const PWCHK_NOT_VALID = '비밀번호가 일치하지 않습니다.';
export const TELNUM_NOT_VALID =
  '휴대폰번호 형식이 아닙니다. -를 제외한 숫자만 입력해주세요.';
